import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { formatDate } from '../utils/helpers';
import { CASE_CATEGORY_MAP, Chip, toDateInput } from '../utils/cases';

const WEEKDAYS = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];

export default function HearingsPage() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [past, setPast] = useState(false);

  useEffect(() => {
    const url = past ? '/cases/hearings/all' : '/cases/hearings/upcoming';
    api.get(url, { params: { days: 365 } }).then(r => setRows(r.data)).catch(() => {});
  }, [past]);

  const today = new Date().toISOString().slice(0, 10);
  const list = past ? rows.filter(h => toDateInput(h.hearing_date) < today) : rows;
  const byDate = {};
  list.forEach(h => { const d = toDateInput(h.hearing_date); (byDate[d] = byDate[d] || []).push(h); });

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Судебные заседания</h1>
        <div style={{ display: 'flex', border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)' }}>
          <button className={`btn btn-sm ${!past ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setPast(false)} style={{ borderRadius: '5px 0 0 5px' }}>Предстоящие</button>
          <button className={`btn btn-sm ${past ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setPast(true)} style={{ borderRadius: '0 5px 5px 0' }}>Прошедшие</button>
        </div>
      </div>
      {!list.length && <div className="empty-state">{past ? 'Прошедших заседаний нет' : 'Предстоящих заседаний нет. Добавьте заседание в карточке дела.'}</div>}
      {Object.entries(byDate).map(([d, hs]) => {
        const dt = new Date(d + 'T00:00:00');
        const isToday = d === today;
        return (
          <div key={d} className="card" style={{ padding: 16, marginBottom: 12, borderLeft: `3px solid ${isToday ? 'var(--red)' : 'var(--accent)'}` }}>
            <div style={{ fontWeight: 700, marginBottom: 8, color: isToday ? 'var(--red)' : 'var(--text)' }}>
              {isToday ? 'Сегодня, ' : ''}{formatDate(d)}, {WEEKDAYS[dt.getDay()]}
            </div>
            {hs.map(h => {
              const cat = CASE_CATEGORY_MAP[h.category] || CASE_CATEGORY_MAP.other;
              return (
                <div key={h.id} onClick={() => navigate(`/cases/${h.case_id}`)} style={{ display: 'flex', gap: 12, alignItems: 'center', padding: '8px 0', borderTop: '1px solid var(--border)', cursor: 'pointer', flexWrap: 'wrap' }}>
                  <div style={{ minWidth: 50, fontWeight: 700 }}>{h.hearing_time || '—'}</div>
                  <div style={{ flex: 1, minWidth: 220 }}>
                    <div style={{ fontWeight: 600 }}>{h.client_name} <Chip color={cat.color}>{cat.label}</Chip></div>
                    <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>
                      {[h.court || h.case_court, h.room ? `зал ${h.room}` : null, h.case_number ? `дело № ${h.case_number}` : null, h.note].filter(Boolean).join(' · ')}
                    </div>
                    {h.outcome && <div style={{ fontSize: 12, marginTop: 2 }}>Итог: {h.outcome}</div>}
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}
